import { useEffect } from "react";

const SITE = "https://mediacrypto.ai";

// Sets per-page <title>, description, canonical, OG/Twitter tags.
// Restores the previous values when the page unmounts.
export default function PageMeta({ title, description, path, noindex = false }) {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const restorers = [];
    const url = SITE + (path || "");

    const prevTitle = document.title;
    if (title) document.title = title;
    restorers.push(() => { document.title = prevTitle; });

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector('meta[' + attr + '="' + key + '"]');
      let created = false;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created = true;
      }
      const prev = el.getAttribute("content");
      el.setAttribute("content", value);
      restorers.push(() => {
        if (created) {
          if (el.parentNode) el.parentNode.removeChild(el);
        } else {
          el.setAttribute("content", prev || "");
        }
      });
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:url", url);
    if (noindex) setMeta("name", "robots", "noindex, follow");

    if (path) {
      let link = document.head.querySelector('link[rel="canonical"]');
      let created = false;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
        created = true;
      }
      const prevHref = link.getAttribute("href");
      link.setAttribute("href", url);
      restorers.push(() => {
        if (created) {
          if (link.parentNode) link.parentNode.removeChild(link);
        } else {
          link.setAttribute("href", prevHref || SITE + "/");
        }
      });
    }

    return () => {
      for (let i = restorers.length - 1; i >= 0; i--) restorers[i]();
    };
  }, [title, description, path, noindex]);

  return null;
}